module.exports = __webpack_public_path__ + "svg/flags/Norfolk Island.svg";